import {
  LoginActionConst,
  SignUpActionConst,
  ClearSignUpFieldsActionConst,
  GetLandlordProfileActionConst,
  LogoutActionConst,
  RestoreStateActionConst,
  ForgotPasswordUserIdActionConst,
} from "../../constants/authActionConst";
const initialState = {
  loader: false,
  loginSuccess: null,
  loginError: null,

  signUpSuccess: null,
  signUpError: null,

  userCompleteProfile: null,

  profileCompleted: false,

  sendProifleSucc: null,
  userCredentials: null,
};
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LoginActionConst.USER_LOGIN_REQUEST:
      state = {
        ...state,
        loader: true,
        signUpError: null,
        signUpSuccess: null,
      };
      break;

    case LoginActionConst.USER_LOGIN_SUCC:
      state = {
        ...state,
        loader: false,
        loginSuccess: action.result,
        loginError: null,
      };
      break;

    case LoginActionConst.USER_LOGIN_FAIL:
      state = {
        ...state,
        loader: false,
        loginError: action.result,
        loginSuccess: null,
      };
      break;

    case ForgotPasswordUserIdActionConst.FORGOT_PASS_USER_ID:
      state = {
        ...state,
        loader: false,
        forgotPassUserId: action.id,
      };
      break;

    case ForgotPasswordUserIdActionConst.CLEAR_USER_ID:
      state = {
        ...state,
        loader: false,
        forgotPassUserId: null,
      };
      break;

    //Sign Up
    case SignUpActionConst.USER_SIGNUP_REQUEST:
      state = {
        ...state,
        loader: true,
      };
      break;

    case SignUpActionConst.USER_SIGNUP_SUCC:
      state = {
        ...state,
        loader: false,
        signUpSuccess: action.result,
        signUpError: null,
      };
      break;

    case SignUpActionConst.USER_SIGNUP_FAIL:
      state = {
        ...state,
        loader: false,
        signUpError: action.result,
        signUpSuccess: null,
      };
      break;

    case ClearSignUpFieldsActionConst.SIGNUP_CLEAR:
      state = {
        ...state,
        loader: false,
        signUpSuccess: null,
        signUpError: null,
        loginError: null,
      };
      break;

    //Landlaord complete profile
    case GetLandlordProfileActionConst.GET_USER_PROFILE_REQ:
      state = {
        ...state,
        loader: true,
      };
      break;

    case GetLandlordProfileActionConst.GET_USER_PROFILE_SUCCESS:
      state = {
        ...state,
        loader: false,
        userCompleteProfile: action.result,
        profileCompleted:
          action?.result?.companyInformation &&
          action?.result?.personalInformation 
          // && action?.result?.bankInformation
            ? true
            : false,
      };
      break;

    case GetLandlordProfileActionConst.GET_USER_PROFILE_FAIL:
      state = {
        ...state,
        loader: false,
        userCompleteProfile: action.result,
      };
      break;

    //Send proiflile action

    case LogoutActionConst.LOGOUT_ACTION:
      state = {
        ...state,
        loader: false,
        loginSuccess: null,
        loginError: null,

        signUpSuccess: null,
        signUpError: null,

        userCompleteProfile: null,

        profileCompleted: false,

        sendProifleSucc: null,
        userCredentials: null,
      };
      break;

    case RestoreStateActionConst.RESTORE_AUTH_STATE:
      state = {
        ...state,
        loginSuccess: action.payload.loginSuccess,
        userCredentials: action.payload.userCredentials,
      };
      break;

    default:
      break;
  }
  return state;
};

export default authReducer;
